import request from '../config/axios-config';

export function getAllArticlesFromApprovedPapers(createdYear, page, query) {
    return (
        request({
            method: 'get',
            url: '/report/article/' + createdYear + "/" + page + query,
        }))
}

export function setDetails(articleDetailsBody) {
    return (
        request({
            method: 'post',
            url: '/report/article-details/',
            data: articleDetailsBody
        }))
}

export function deleteArticle(articleId) {
    return (
        request({
            method: 'post',
            url: '/report/delete/article/' + articleId,
        }))
}



